import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export enum DealsTabValue {
  all = 'false',
  deals = 'true',
}

export const useDealsTabsOpenedState = () => {
  const {parameter, ...rest} = useOpenedStateManager('discount-tabs-state', {
    controlParams: [
      {
        urlSearchParam: 'hasCampaignReduction',
        allowedValues: [DealsTabValue.all, DealsTabValue.deals],
      },
    ],
  });

  return {
    ...rest,
    parameter: parameter || DealsTabValue.all,
  };
};
